import React from 'react';
import { Link } from 'react-router-dom';
import { AppIcon } from './AppIcon.js';

export const GettingStarted: React.FC<{ readonly preview?: boolean }> = ({ preview = false }) => (
  <section className="panel getting-started" aria-label="Getting started">
    <div className="section-heading">
      <div>
        <h2>{preview ? 'From crypto to card' : 'Welcome to PAY888'}</h2>
        <p className="muted">
          {preview
            ? 'Explore the steps with sample data.'
            : 'Set up your profile, then explore your card.'}
        </p>
      </div>
    </div>
    <ol className="getting-started-steps">
      <li>
        <span className="icon-tile">
          <AppIcon name="settings" />
        </span>
        <div>
          <h3>Your profile</h3>
          <p>Add your display name to personalize the card preview.</p>
        </div>
        <Link to={preview ? '/preview/settings' : '/settings'}>Edit profile ↗</Link>
      </li>
      <li>
        <span className="icon-tile">
          <AppIcon name="wallet" />
        </span>
        <div>
          <h3>Top up with crypto</h3>
          <p>Choose a supported coin and network when funding becomes available.</p>
        </div>
        <span className="subtle-pill">Coming soon</span>
      </li>
      <li>
        <span className="icon-tile">
          <AppIcon name="card" />
        </span>
        <div>
          <h3>Choose your card</h3>
          <p>Explore card controls. Issuing and reloading are not available yet.</p>
        </div>
        <Link to="/preview/cards">Preview cards ↗</Link>
      </li>
    </ol>
  </section>
);
